export default "__VITE_ASSET__Ba0p5E87__"